import { AbstractControl } from '@angular/forms';

export function ValidateNotEmpty(control: AbstractControl) {
  if (isNullOrSpaces(control.value)) {
    return { empty: true };
  }
  return null;
}

function isNullOrSpaces(s: string): boolean {
  return s === null || s.match(/^ *$/) !== null;
}


